import React from 'react';
import OmegaImage from '../../../assets/omega3/omega3.webp';
import BagImage from '../../../assets/bag.webp';
import CreatineImage from '../../../assets/creatine.webp';
import CapImage from '../../../assets/riise-cap.webp';

const SEGMENTS = ['omega', 'creatine', 'cap', 'bag', 'omega', 'creatine', 'cap', 'bag'];
const IMAGES = { omega: OmegaImage, creatine: CreatineImage, cap: CapImage, bag: BagImage };

export const GiftStatusIcon = ({ type, className = '' }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={type === 'check' ? 2.4 : 1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {type === 'check' && <path d="M3 8.5l3.2 3L13 4.5" />}
    {type === 'lock' && (
      <>
        <rect x="3" y="7" width="10" height="7" rx="1.8" />
        <path d="M5.2 7V5a2.8 2.8 0 015.6 0v2" />
      </>
    )}
    {type === 'renewal' && (
      <>
        <path d="M13 8a5 5 0 01-9 3M3 8a5 5 0 019-3" />
        <path d="M12.5 2v3h-3M3.5 14v-3h3" />
      </>
    )}
  </svg>
);

export const GiftBox = () => (
  <div
    aria-hidden="true"
    className="t-relative t-mx-auto t-mb-2 t-mt-3 t-h-[98px] t-w-[104px] motion-safe:t-animate-gift-bob"
  >
    <div className="t-absolute t-bottom-0 t-left-[10px] t-right-[10px] t-h-[58px] t-rounded-t-[4px] t-rounded-b-xl t-bg-navy before:t-absolute before:t-inset-y-0 before:t-left-1/2 before:t--ml-2 before:t-w-4 before:t-bg-butter before:t-content-['']" />
    <div className="t-absolute t-bottom-[52px] t-left-0.5 t-right-0.5 t-h-6 t-rounded-[7px] t-bg-quiz-teal before:t-absolute before:t-inset-y-0 before:t-left-1/2 before:t--ml-2 before:t-w-4 before:t-bg-butter before:t-content-['']">
      <span className="t-absolute t--top-[14px] t-left-1/2 t--ml-4 t-h-7 t-w-[42px] t-rounded-[50%_50%_50%_50%/80%_80%_20%_20%] t-border-[5px] t-border-solid t-border-butter" />
    </div>
    <span className="t-absolute t--bottom-1.5 t-right-0 t-grid t-h-8 t-w-8 t-place-items-center t-rounded-full t-border-2 t-border-solid t-border-navy t-bg-white t-text-navy">
      <GiftStatusIcon type="lock" className="t-h-[15px] t-w-[15px]" />
    </span>
  </div>
);

export const PrizeWheel = ({ wheelRef, label }) => (
  <div aria-hidden="true" className="t-relative t-mx-auto t-mt-1 t-aspect-square t-w-full t-max-w-[300px]">
    <div
      ref={wheelRef}
      className="t-absolute t-inset-0 t-origin-center t-overflow-hidden t-rounded-full t-border-[6px] t-border-solid t-border-butter t-shadow-[0_10px_30px_rgba(0,0,0,0.35)] t-bg-[conic-gradient(from_-22.5deg,#F7E96B_0_45deg,#FFFFFF_45deg_90deg,#E3F0EE_90deg_135deg,#FFFFFF_135deg_180deg,#F7E96B_180deg_225deg,#FFFFFF_225deg_270deg,#E3F0EE_270deg_315deg,#FFFFFF_315deg_360deg)] before:t-absolute before:t-inset-0 before:t-bg-[repeating-conic-gradient(from_-22.5deg,rgba(16,54,66,0.22)_0_0.6deg,transparent_0.6deg_45deg)] before:t-content-['']"
    >
      <svg viewBox="0 0 288 288" className="t-relative t-z-[1] t-block t-h-full t-w-full t-overflow-visible">
        {SEGMENTS.map((prize, index) => (
          <g key={`prize-${index}`} transform={`rotate(${index * 45} 144 144)`}>
            <foreignObject x="112" y="9" width="64" height="78" className="t-overflow-visible">
              <div className="t-flex t-h-[78px] t-w-16 t-flex-col t-items-center t-justify-start t-gap-[3px]">
                <span className="t-whitespace-nowrap t-text-[10px] t-font-extrabold t-leading-none t-tracking-[0.01em] t-text-navy">
                  {label(prize)}
                </span>
                <span className="t-inline-grid t-h-14 t-w-14 t-flex-none t-place-items-center t-overflow-hidden">
                  <img
                    src={IMAGES[prize]}
                    alt=""
                    className={`t-block t-h-full t-w-full t-object-contain ${prize === 'omega' ? '' : prize === 'bag' ? 't-p-1.5' : 't-p-[5px]'}`}
                  />
                </span>
              </div>
            </foreignObject>
          </g>
        ))}
      </svg>
    </div>
    <span className="t-absolute t-left-1/2 t-top-1/2 t-z-[2] t--ml-[27px] t--mt-[27px] t-grid t-h-[54px] t-w-[54px] t-place-items-center t-rounded-full t-bg-butter t-text-base t-leading-[normal] t-font-extrabold t-text-navy t-shadow-[0_3px_10px_rgba(0,0,0,0.35)]">
      r.
    </span>
    <span className="t-absolute t--top-[10px] t-left-1/2 t-z-[3] t-h-0 t-w-0 t--translate-x-1/2 t-border-x-[13px] t-border-t-[26px] t-border-solid t-border-x-transparent t-border-t-butter t-drop-shadow-[0_3px_3px_rgba(0,0,0,0.3)]" />
  </div>
);
